import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App.jsx";
import Home from "./pages/Home.jsx";
import Profile from "./pages/Profile.jsx";
import AdminEvents from "./pages/AdminEvents.jsx";
import DevLogs from "./pages/DevLogs.jsx";

// TEMP: keep other tabs showing something until you replace them
import { Announcements, Events, Ads, AdminUsers, AdminSystem } from "./pages/_stubs.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/profile", element: <Profile /> },
      { path: "/announcements", element: <Announcements /> },
      { path: "/events", element: <Events /> },
      { path: "/ads", element: <Ads /> },

      // real pages:
      { path: "/admin/events", element: <AdminEvents /> },
      { path: "/dev/logs", element: <DevLogs /> },

      // stubs kept for now:
      { path: "/admin/users", element: <AdminUsers /> },
      { path: "/admin/system", element: <AdminSystem /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(<RouterProvider router={router} />);
